import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";

let PlanDetailsPageComponent = {
    selector: "vcPlanDetailsPage",
    templateUrl: "/angular/components/profile/plan-details-page.component.html",
    bindings: {},
    controller: class PlanDetailsPageController {
        public campaign: Campaign;

        constructor(CampaignDataProvider: CampaignDataProvider) {
            this.campaign = CampaignDataProvider.getActiveCampaign();
        }
    },
};

angular
    .module("profile")
    .component(PlanDetailsPageComponent.selector, PlanDetailsPageComponent);
